import { Filter } from 'services/recipes-landing-service';

export const emptyFilter: Filter = {
  title: '',
  values: [],
};
